import { useEffect } from "react"
import { useMyTheme } from "../../ThemeProviderWrapper";
import { createTheme, useMediaQuery } from "@mui/material";

const SetTheme = ({ setTheme, customDetails }) => {
  const { changeTheme } = useMyTheme();
  const mobileScreen = useMediaQuery('(max-width:900px)');
  
  useEffect(() => {
    // Check if dark theme is enabled
    const isDarkTheme = customDetails?.darkTheme === true;
    
    // Set data attribute for CSS variables
    document.documentElement.setAttribute('data-theme', isDarkTheme ? 'dark' : 'light');
    
    let newTheme = createTheme({
      palette: {
        mode: isDarkTheme ? 'dark' : 'light',
        primary: {
          light: customDetails.secondaryColor,
          main: customDetails.primaryColor,
          white: "#FFFFFF",
        },
        secondary: {
          main: customDetails.secondaryColor,
          light: "#E3E9EE"
        },
        error: {
          main: "#E94B4B",
        },
        success: {
          main: "#20BE79",
          light: "#4de6a3",
        },
        info: {
          main: isDarkTheme ? "#FFFFFF" : "#000000",
          light: isDarkTheme ? "#161616" : "#F3F5FD",
        },
        textColor: customDetails.textColor,
        black60: isDarkTheme ? "#7A8185" : "#81858F",
        black40: isDarkTheme ? "#A5AAB8" : "#A5AAB8",
        backgroundMobileSubHeader: isDarkTheme ? "#161616" : "#2B3056",
        textBlack: isDarkTheme ? "#FFFFFF" : "#111111",
        tagRed: {
          main: "#CA2626",
          light: "#FDEDED",
        },
        // Dark theme specific colors
        background: {
          default: isDarkTheme ? "#161616" : "#FFFFFF",
          paper: isDarkTheme ? "#161616" : "#FFFFFF",
        },
        text: {
          primary: customDetails.primaryTextColor || (isDarkTheme ? "#FFFFFF" : "#000000"),
          secondary: customDetails.secondaryTextColor || (isDarkTheme ? "#7A8185" : "#81858F"),
        },
      },
      typography: {
        fontFamily: customDetails.fontFamily
      },
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              borderRadius: "14px",
              borderColor: isDarkTheme ? customDetails.borderColor || "#161616" : "#D8E1EE",
            },
            root: {
              '& label': {
                color: customDetails.primaryColor,
              },
              '& label.Mui-focused': {
                color: customDetails.primaryColor,
              },
              '& .MuiInput-underline:after': {
                borderBottomColor: customDetails.primaryColor,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: customDetails.primaryColor,
                },
                '&:hover fieldset': {
                  borderColor: customDetails.primaryColor,
                },
                '&.Mui-focused fieldset': {
                  borderColor: customDetails.primaryColor,
                },
            }
          },
        },
      },
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: customDetails.borderRadius,
              backgroundColor: customDetails.ctaBackgroundColor || customDetails.primaryColor,
              color: customDetails.ctaTextColor || (isDarkTheme ? "#000000" : "#FFFFFF"),
              '&:hover': {
                backgroundColor: customDetails.ctaHoverPrimaryColor || customDetails.primaryColor,
              },
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: isDarkTheme ? "#161616" : "#FFFFFF",
              color: isDarkTheme ? "#FFFFFF" : "#000000",
            },
          },
        },
        MuiChip: {
          styleOverrides: {
            root: {
              backgroundColor: isDarkTheme ? "#161616" : "#FFFFFF",
              color: isDarkTheme ? "#7A8185" : "#81858F",
              borderColor: isDarkTheme ? "#161616" : "#81858F",
            },
          },
        },
        MuiListItemAvatar: {
          styleOverrides: {
            root: {
              minWidth: "unset",
            }
          }
        },
        MuiFab: {
          styleOverrides: {
            root: {
              boxShadow: "unset",
              transition: "unset"
            }
          }
        },
        MuiListItemIcon: {
          styleOverrides: {
            root: {
              minWidth: "unset",
              paddingRight: "0.25rem"
            }
          }
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              fontSize: mobileScreen ? "1rem" : "0.875rem"
            }
          }
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              color: isDarkTheme ? '#7A8185' : '#D8E1EE',
              '&.Mui-checked': {
                color: customDetails.primaryColor || '#3053D3',
              },
              '&.Mui-disabled': {
                color: isDarkTheme ? '#7A8185' : '#D8E1EE',
              },
            },
          },
        },
      },
    });
    changeTheme(newTheme);
    setTheme(newTheme)
    return () => null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default SetTheme;